import { Form, Formik } from "formik";
import { Button, Card, CardBody, FormGroup, Input, Label } from "reactstrap";
import { useGebruikerContext } from "../../Context/GebruikerContext";
import { useAlgemeenContext } from "./Context/AlgemenContext";

const ContactDetails = () => {
	const { userDetails: data, disable } = useGebruikerContext();
	const { handleFieldChange, errorField, handleSave } = useAlgemeenContext();
	const defaultValues = {
		iMobileNumber: data?.iMobileNumber || "",
		vEmail: data?.vEmail || "",
		vPhonePrivate: data?.vPhonePrivate || "",
		vBusinessEmail: data?.vBusinessEmail || "",
		vPhoneWork: data?.vPhoneWork || "",
	};

	return (
		<Card className="main-card h-110">
			<CardBody className="d-flex flex-column ">
				<h5 className="mb-4">Contactgegevens</h5>
				<Formik enableReinitialize initialValues={defaultValues} onSubmit={(values) => {
				
					handleSave(values);
				}}>
					{({ values, handleChange }) => (
						<Form>
							<FormGroup
								  className={`form-element ${ errorField?.["attr.iMobileNumber"] ? "error" : ""
									}`}
							>
								<Label for="iMobileNumber">Mobiele telefoon</Label>
								<Input
									name="iMobileNumber"
									type="text"
									value={values.iMobileNumber}
									onChange={handleChange}
									disabled={disable}
								/>
							</FormGroup>
							<FormGroup
								className={`form-element ${ errorField?.["attr.vEmail"] ? "error" : ""}`}
							>
								<Label for="vEmail">E-mail privé</Label>
								<Input
									name="vEmail"
									type="text"
									value={values.vEmail}
									onChange={handleChange}
									disabled={disable}
								/>
							</FormGroup>
							<FormGroup
								className={`form-element ${errorField?.["attr.vPhonePrivate"]  ? "error" : ""
									}`}
							>
								<Label for="vPhonePrivate">Telefoon privé</Label>
								<Input
									name="vPhonePrivate"
									type="text"
									value={values.vPhonePrivate}
									onChange={handleChange}
									disabled={disable}
								/>
							</FormGroup>
							<FormGroup
								   className={`form-element ${ errorField?.["attr.vBusinessEmail"]? "error" : ""
									}`}
							>
								<Label for="vBusinessEmail">E-mail werk</Label>
								<Input
									name="vBusinessEmail"
									type="text"
									value={values.vBusinessEmail}
									onChange={handleChange}
									disabled={disable}
								/>
							</FormGroup>
							<FormGroup
							 className={`form-element ${  errorField?.["attr.vPhoneWork"] ? "error" : ""
									}`}
							>
								<Label for="vPhoneWork">Telefoon werk</Label>
								<Input
									name="vPhoneWork"
									type="text"
									value={values.vPhoneWork}
									onChange={handleChange}
									disabled={disable}
								/>
							</FormGroup>
							<div className="d-flex justify-content-end">
								<Button outline
									className="btn-outline-primary-blue btn-color-style py-2 px-3 d-flex gap-2 align-items-center mt-2"
									type="submit">
									Opslaan
								</Button>
							</div>
						</Form>
					)}
				</Formik>
			</CardBody>
		</Card>
	);
};

export default ContactDetails;
